import { Component, OnDestroy, OnInit } from '@angular/core';
import { finalize, Subscription } from 'rxjs';
import { EmployeesService } from '../../../employees/employees.service';
import { Employee } from '../../../employees/employees.model';
import { buildFilterQuery, getDefaultProfilePicUrl, handleImageError } from '../../../utils';
import { PaginatedResponse } from '../../../common/models/common.model';

@Component({
  selector: 'app-employee-travel-reports',
  standalone: false,
  templateUrl: './employee-travel-reports.component.html',
})
export class EmployeeTravelReportsComponent implements OnInit, OnDestroy {
  protected isLoading: boolean = false;
  protected employees: Employee[] = [];
  protected hasNextPage = false;
  protected hasPreviousPage = false;
  protected totalCount: number = 0;
  protected searchTerm: string = '';
  protected currentPage: number = 1;

  private _subscription!: Subscription;
  private _searchDebounceTimer: any;

  constructor(private _employeesService: EmployeesService) {}

  ngOnInit(): void {
    this._getEmployees();
  }

  protected onPageChange(page: number): void {
    this.currentPage = page;
    this._getEmployees();
  }

  protected onSearchKeyUp(): void {
    clearTimeout(this._searchDebounceTimer);
    this._searchDebounceTimer = setTimeout(() => {
      this.currentPage = 1;
      this._getEmployees();
    }, 500);
  }

  protected onClearSearch(): void {
    clearTimeout(this._searchDebounceTimer);
    this.searchTerm = '';
    this.currentPage = 1;
    this._getEmployees();
  }

  private _getEmployees(): void {
    this.isLoading = true;
    const params = buildFilterQuery({
      page: this.currentPage,
      search: this.searchTerm,
      team: 'sales',
    });

    this._subscription = this._employeesService
      .list(params)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res: PaginatedResponse<Employee>) => {
          this.employees = res.results || [];
          this.hasNextPage = !!res.next;
          this.hasPreviousPage = !!res.previous;
          this.totalCount = res.count;
        },
      });
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  protected readonly getDefaultProfilePicUrl = getDefaultProfilePicUrl;
  protected readonly handleImageError = handleImageError;
}
